import React from "react";
import PropTypes from "prop-types";
import Button from "../../ui/Button";
import Modal from "../../ui/Modal";

const LoginRequiredModal = ({ isOpen, onClose, title }) => {
  const modalTitle =
    title || I18n.t("recycled_inquiries.index.login_required.title");
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div
        style={{
          textAlign: "center",
          padding: 32,
          maxWidth: 400,
          margin: "0 auto",
        }}
      >
        <h2 style={{ marginBottom: 24 }}>{modalTitle}</h2>
        <Button
          primary
          onClick={() => {
            const path =
              window.location.pathname +
              window.location.search +
              window.location.hash;
            const returnTo = encodeURIComponent(path);
            const localePrefix =
              typeof I18n !== "undefined" &&
              I18n.locale &&
              I18n.defaultLocale &&
              I18n.locale !== I18n.defaultLocale
                ? `/${I18n.locale}`
                : "";
            window.location.href = `${localePrefix}/users/sign_in?return_to=${returnTo}`;
          }}
        >
          {I18n.t("recycled_inquiries.index.login_required.button")}
        </Button>
        <div style={{ height: 32 }} />
        <div style={{ fontSize: 14, color: "#666", marginBottom: 24 }}>
          {I18n.t(
            "recycled_inquiries.index.login_required.not_part_of_community",
          )}
        </div>
        <Button
          inverse
          onClick={() => {
            const localePrefix =
              typeof I18n !== "undefined" &&
              I18n.locale &&
              I18n.defaultLocale &&
              I18n.locale !== I18n.defaultLocale
                ? `/${I18n.locale}`
                : "";
            window.location.href = `${localePrefix}/for-artists`;
          }}
        >
          {I18n.t("recycled_inquiries.index.login_required.apply_now_button")}
        </Button>
      </div>
    </Modal>
  );
};

export default LoginRequiredModal;

LoginRequiredModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};

LoginRequiredModal.defaultProps = {
  title: null,
};
